/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {isAnEmail} from "../../../tools/utils/Utils";
import ClientService from "../../../services/ClientService";
import Client from "../../Client";
import {SelectField} from "../../../tools/model/form/SelectField";
import {TextField} from "../../../tools/model/form/TextField";
import {Selectable} from "../../../tools/model/form/Selectable";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {UserAddDTO} from "../../dto/user/UserAddDTO";


export default class UserAddForm extends AbstractForm<UserAddDTO> {
    constructor(clients: Array<Client>) {
        super();

        let selectableValues: Array<Selectable<Client>> = ClientService.convertToSelectable(clients);

        this.fields.set(UserAddDTO.EMAIL, new TextField(
            UserAddDTO.EMAIL,
            (t: Translation) => t.userListColID,
            value => isAnEmail(value.toString()),
            Type.EMAIL,
            true,
            "harold.fritsch@hilo3d.com",
            ""
        ));

        this.fields.set(UserAddDTO.FIRSTNAME, new TextField(
            UserAddDTO.FIRSTNAME,
            (t: Translation) => t.userListColFirstName,
            value => value.toString().length !== 0,
            Type.TEXT,
            true,
            "Harold",
            ""
        ));

        this.fields.set(UserAddDTO.LASTNAME, new TextField(
            UserAddDTO.LASTNAME,
            (t: Translation) => t.userListColLastName,
            value => value.toString().length !== 0,
            Type.TEXT,
            true,
            "Fritsch",
            ""
        ));

        this.fields.set(UserAddDTO.PASSWORD, new TextField(
            UserAddDTO.PASSWORD,
            (t: Translation) => t.userListColLastPwd,
            value => value.toString().length >= 6,
            Type.PASSWORD,
            true,
            "bonjour",
            "",
            false,
            (t: Translation) => t.formPasswordInvalid,
        ));

        this.fields.set(UserAddDTO.PHONE, new TextField(
            UserAddDTO.PHONE,
            (t: Translation) => t.userListColPhone,
            value => value.toString().length >= 10,
            Type.TELEPHONE,
            true,
            "0664458146",
            "",
            false,
            (t: Translation) => t.formInvalidField,
        ));

        this.fields.set(UserAddDTO.CLIENT_IDS, new SelectField(
            selectableValues,
            "client_ids",
            (t: Translation) => t.userListClientsIds,
            () => true,
            Type.SELECT,
            true,
            true,
            [],
            []
        ));
    }

    /**
     * load
     * @param dto
     */
    public load(dto: UserAddDTO): void {
        const firstnameField = this.fields.get(UserAddDTO.FIRSTNAME);
        if (firstnameField) firstnameField.value = dto.firstname;

        const lastnameField = this.fields.get(UserAddDTO.LASTNAME);
        if (lastnameField) lastnameField.value = dto.lastname;

        const passwordField = this.fields.get(UserAddDTO.PASSWORD);
        if (passwordField) passwordField.value = dto.password;

        const emailField = this.fields.get(UserAddDTO.EMAIL);
        if (emailField) emailField.value = dto.email;

        const phoneField = this.fields.get(UserAddDTO.PHONE);
        if (phoneField) phoneField.value = dto.phone;

        const clientIdsField = this.fields.get(UserAddDTO.CLIENT_IDS);
        if (clientIdsField) clientIdsField.value = dto.client_ids;
    }
}
